<style lang="less" scoped>
#csv {
  display: none;
}
/deep/.el-form-item__content {
  width: 240px !important;
}
.hide {
  visibility: hidden;
}
.page-main .page-content .content .searchs .subbtn {
  margin: 0;
  position: relative;
  top: 1px;
}
.table-list {
  padding: 20px 0;
  height: 34px;
}
</style>
<template>
  <div>
    <div class="page-main">
      <div class="page-main-top">
        <div class="page-content">
          <div class="title">历史查询</div>
          <div class="content">
            <el-form
              label-width="120px"
              :rules="rules"
              :model="ruleForm"
              ref="ruleForm"
            >
              <el-row :gutter="10">
                <el-col :span="24">
                  <div class="searchs">
                    <el-form-item label="时间" prop="startTime">
                      <el-date-picker
                        v-model="ruleForm.startTime"
                        type="datetime"
                        :default-time="'00:00:00'"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="开始时间"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                    <div class="interval">-</div>
                    <el-form-item label label-width="0" prop="endTime">
                      <el-date-picker
                        v-model="ruleForm.endTime"
                        type="datetime"
                        :default-time="'23:59:59'"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="结束时间"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="searchs">
                    <el-form-item label="自动站/设备" prop="station">
                      <el-select
                        v-model="ruleForm.station"
                        clearable
                        placeholder="选择自动站"
                        @change="selectStation"
                      >
                        <el-option
                          v-for="(item, index) in stationList"
                          :key="index"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <div class="interval hide">-</div>
                    <el-form-item label label-width="0">
                      <el-select
                        v-model="ruleForm.device"
                        clearable
                        placeholder="选择设备"
                      >
                        <el-option
                          v-for="(item, index) in deviceList"
                          :key="index"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="searchs">
                    <el-form-item label="报警类型">
                      <el-select
                        v-model="ruleForm.alarm_type"
                        clearable
                        placeholder="选择自动站"
                      >
                        <el-option
                          v-for="(item, index) in alarmTypeList"
                          :key="index"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <div class="interval hide">-</div>
                    <el-button
                      class="subbtn"
                      @click="searchBtn()"
                      type="primary"
                      :loading="submitBtn.isBtnLoading"
                      :disabled="submitBtn.isDisabled"
                      >{{ submitBtn.btnText }}</el-button
                    >
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
      <div class="page-main-bottom">
        <div class="content-list">
          <div class="page-content">
            <div class="content">
              <div class="table">
                <el-table
                  :data="tableData"
                  stripe
                  size="mini"
                  border
                  v-loading="pageLoading"
                >
                  <el-table-column label="自动站名称" align="center">
                    <template slot-scope="scope">
                      <div>
                        <router-link class="font-color-theme cursor-pointer" :to="{name:'classify', params: {id:scope.row.device_detail.station_id}}">{{scope.row.station_name}}</router-link>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-for="(item, key) in thTableList"
                    :key="key"
                    :prop="item.param"
                    align="center"
                    :label="item.title"
                  >
                    <template slot-scope="scope">
                      <div v-if="item.param === 'alarmType'">
                        <div :class="scope.row.alarmType.className">
                          {{ scope.row.alarmType.name }}
                        </div>
                      </div>
                      <div v-else-if="item.param === 'device_name'">
                        <router-link
                          class="font-color-theme cursor-pointer"
                          :to="
                            pbFunc.stationTypePath(
                              scope.row.device_detail.device_type_code,
                              scope.row.device_detail.station_id,
                              scope.row.device_detail.device_id
                            )
                          "
                          >{{scope.row[item.param]}}</router-link>
                        
                      </div>
                      <div v-else>{{ scope.row[item.param] }}</div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div
              class="table-list text-center"
              v-show="pageData.totalCount > 20"
            >
              <el-pagination
                background
                layout="prev, pager, next, jumper"
                :total="pageData.totalCount"
                :page-size="pageData.pageSize"
                :current-page.sync="pageData.currentPage"
                @current-change="pageChange"
                v-if="!pageLoading && pageData.totalCount > 20"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import alarmTable from "@/components/alarmTable"; //报警列表
export default {
  name: "alarmHistory", //警报历史查询
  components: {
    alarmTable: alarmTable
  },
  data() {
    return {
      pageLoading: false, //页面loading
      tableData: [],
      ruleForm: {
        startTime: "",
        endTime: "",
        device: "", //设备
        station: "", //自动站
        alarm_type: "", //报警类型
        read_status: 2 //消息状态
      },
      stationList: [
        {
          name: "全部",
          id: ""
        }
      ], //自动站列表
      deviceList: [
        {
          name: "全部",
          id: ""
        }
      ], //设备列表
      alarmTypeList: [
        {
          name: "全部",
          id: ""
        },
        {
          name: "设备离线",
          id: 1
        },
        {
          name: "高高报警",
          id: 2
        },
        {
          name: "高报警",
          id: 3
        },
        {
          name: "设备离线恢复",
          id: 4
        },
        {
          name: "高高报警恢复",
          id: 5
        },
        {
          name: "高报警恢复",
          id: 6
        }
      ], //报警类型
      rules: {},
      submitBtn: {
        btnText: "查询历史",
        isLoading: false,
        isDisabled: false
      },
      pageData: {
        currentPage: 1,
        totalCount: "",
        pageSize: 20
      },
      thTableList: [
        {
          title: "设备编号",
          param: "device_sn",
          width: ""
        },
        {
          title: "设备名",
          param: "device_name",
          width: ""
        },
        {
          title: "报警类别",
          param: "alarmType",
          className: "",
          width: ""
        },
        {
          title: "报警项目",
          param: "alarm_field",
          width: ""
        },
        {
          title: "测量数据",
          param: "alarm_data",
          width: ""
        },
        {
          title: "报警时间",
          param: "alarm_time",
          width: ""
        }
      ],
      station: [], //自动站
      postData:{}
    };
  },
  computed: {},
  methods: {
    searchBtn(){
        this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.postData = this.pbFunc.deepcopy(this.ruleForm);
          let startDate = new Date(this.ruleForm.startTime);
          let endDate = new Date(this.ruleForm.endTime);
          if (startDate > endDate) {
            this.$message.error("开始时间不能大于结束时间");
            return false;
          }
          let time = this.ruleForm.startTime
                ? this.ruleForm.startTime + "," + this.ruleForm.endTime
                : "";
          this.postData.time = time;
          this.pageData.currentPage = 1;
          this.search();
        }
      });
    },
    search() {
      this.pageLoading = true;
      this.$$http("alarmList", {
        alarm_type: this.ruleForm.alarm_type, //报警类型
        // read_status: this.ruleForm.read_status, //消息状态
        station: this.postData.station,
        device: this.postData.device,
        alarm_time__range: this.postData.time,
        page: this.pageData.currentPage,
        size: this.pageData.pageSize
      })
        .then(results => {
          this.pageLoading = false;
          //   this.nuclideData = [];
          if (results.data && results.status == 200) {
            this.pageData.totalCount = results.data.count;
            this.tableData = results.data.results;
            for (let i in this.tableData) {
              this.tableData[i].alarmType = this.pbFunc.alarmTypeName(
                this.tableData[i].alarm_type
              );
            }
            console.log("this.tableData", this.tableData);
          } else {
            this.$message.error(
              results.data.msg ? results.data.msg : "查询失败"
            );
          }
        })
        .catch(err => {
          this.pageLoading = false;
        });
     
    },
    pageChange() {
      setTimeout(() => {
        this.search();
      });
    },
    //获取自动站、设备
    getStation() {
      this.$$http("automaticStation", {})
        .then(results => {
          if (results.data && results.status == 200) {
            let list = [
              {
                name: "全部",
                id: ""
              }
            ];
            this.stationList = list.concat(results.data.results);
          }
        })
        .catch(err => {});
    },
    //选择自动站
    selectStation(id) {
      let list = [
        {
          name: "全部",
          id: ""
        }
      ];
      if (id) {
        for (let i in this.stationList) {
          if (this.stationList[i].id === id) {
            this.deviceList = list.concat(this.stationList[i].devices);
          }
        }
      } else {
        this.ruleForm.device = "";
      }
    }
  },
  created() {
    this.getStation();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/giveAnAlarm/alarmHistory.vue